<div class="headerTitle">
  <h5>{{ 'Sellers.Bill_Payment.Bill_Payments' | translate}}</h5>
  <i class="fas fa-chevron-right"></i>
  <h5>{{ 'Sellers.Bill_Payment.Categories' | translate}}</h5>
</div>

<div class="cardItem">
  <div class="container">
    <div class="box" *ngFor="let item of categories;let i = index">
      <img [src]="item.image" />
      <div class="info" (click)="onClickCategory(item.ID)">
        <p>{{item.name}}</p>
        <i class="fas fa-long-arrow-alt-right"></i>
      </div>
    </div>
  </div>
</div>
